<template>
  <div class="MainStepsForm OnSaleForm">
    <div class="container">

      <div class="commonWhiteBg">
        <div class="commonTitle"> 合约挂卖 </div>
        <div class="formWrap">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="140px"
          >
           <el-form-item
              label="选择存证文件"
              prop="evidenceFileIdx"
            >
              <el-select
                v-model="form.evidenceFileIdx"
                clearable
                placeholder="请选择已存证名称"
                @change="chooseFile"
              >
                <el-option
                  v-for="(item, index) in fileList"
                  :key="index"
                  :label="item.sourceName"
                  :value="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item
              label="选择类型"
              prop="agreementType"
            >
              <el-select
                v-model="form.agreementType"
                clearable
                placeholder="请选择已存证名称"
              >
                <el-option
                  v-for="item in agreementTypeOpt"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="选择分类"
              prop="categoryId"
            >
              <el-select
                v-model="form.categoryId"
                  clearable
                placeholder="请选择分类"
              >
                <el-option
                  v-for="(item,index) in queryProductCategory"
                  :key="index"
                  :label="item.name"
                  :value="item.categoryId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="创建标题"
              prop="subject"
            >
              <el-input v-model="form.subject"></el-input>
            </el-form-item>
              <!-- <el-form-item
              label="书名"
              prop="bookName"
            >
              <el-input v-model="form.bookName"></el-input>
            </el-form-item> -->
              <el-form-item
              label="作者"
              prop="author"
            >
              <el-input v-model="form.author"></el-input>
            </el-form-item>
              <el-form-item
              label="创建关键词"
              prop="keyWords"
            >
             <el-input v-model="form.keyWords"></el-input>
            </el-form-item>
             <el-form-item
              label="挂卖内容简介"
              prop="description"
            >
              <el-input
                v-model="form.description"
                :rows="3"
                placeholder="请输入您对挂卖内容的内容简介"
                type="textarea"
              ></el-input>
            </el-form-item>
              <el-form-item
              label="原文摘录"
              prop="description2"
            >
              <el-input
                v-model="form.description2"
                :rows="3"
                placeholder="请输入精彩的原文摘录"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="电子书封面"
              class="uploadWraper"
                ref="uploader"
                prop="identityPicture"
            >
                <el-upload class="commonFaceUploader" :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess"
								 :before-upload="uploadBefore">
									<img v-if="form.identityPicture" :src="form.identityPicture" class="avatar">
                  <div v-else> 
                     <i class="el-icon-plus avatar-uploader-icon"></i>
                     <p class="mt8"> 上传电子书封面 </p>
                     <p class="mt8 sizeTips"> 尺寸：270px*360px </p>
                  </div>
									
								</el-upload>
            </el-form-item>
              <el-form-item
              label="输入售卖金额"
              prop="description2"
            >
              <el-input
                v-model="form.price"
                type="number"
              ></el-input>
              <div class="rightTips"> 
                  <div class="round"> </div>
                  <div class="ract"> </div>
                  <div class="rightWords">
                      <p> <strong class="el-icon-caret-right"> </strong> <strong class="num"> 99</strong> <span class="text"> 售卖金额的99%属于您的商品收益</span> </p>
                      <p> <strong class="el-icon-caret-right"> </strong> <strong  class="num"> 1</strong> <span class="text"> 平台将收取售卖金额的1%作为手续费</span>  </p>
                  </div>
              </div>
            </el-form-item>
             <el-form-item prop="allow">
                     <el-checkbox v-model="form.allow">我同意</el-checkbox>
                      <router-link :to="{path:'/Contract',query: {}}"> 
                          《知链电子书挂卖合约协议》
                      </router-link>
                 </el-form-item>
            <el-form-item class="submitRow">
              <el-button
                type="primary"
                @click="onSubmit"
              >开始挂卖</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { queryExistOrderItems , applyProduct , applyGood } from "@/api/EvidenceService";
import { mixinsScrollErrorPosition } from '../../../../mixins'
import { queryProductCategory } from "@/api/ObtainEvidence";
export default {
  name: 'ObtainEvidenceInputForm',
  mixins: [mixinsScrollErrorPosition],
  components: { },
  data () {
    return {
      fileList: [],
      form: {
        agreementType: '',// 合约类型
        subject: '', // 创建标题
        evidenceFileIdx: '', // 存证文件
        evidenceFile: '',
        bookName:'',// 书名
        author:'',// 作者
        keyWords:'', //关键词
        description:'', // 挂卖内容简介
        description2:'', // 原文摘录
        identityPicture:'', // 封面
        price:'' ,// 金额
        allow:false,
        categoryId: '',
        downloadUrl: '',
        orderNo: '',
      },
      rules: {
        subject: [
          { required: true, message: '请输入取证名称', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
         identityPicture:[
           { required: true, message: '请上传电子书封面', trigger: 'change' },
        ]
      },
      uploadUrl:`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/`,
      uploadHeaders:{ 
         'Authorization': this.$store.getters.token,
         'Product-Mode': "READ",
         'Terminal-Code': "IPCHAIN2"+ this.$store.getters.terminalCode,
         'Terminal-Type': "WEB",
         'Merchant-Id': "2"
         },
         agreementTypeOpt:[
           {
              value: '00',
              label:'电子书'
            },{
              value: '10',
              label:'文章'
            },{
              value: '20',
              label:'视频'
            },{
              value: '30',
              label:'音频'
            }
         ],
         queryProductCategory: [],
         productId: '',
    }
  },
mounted(){
  this.init()
},
 computed: {
    ...mapGetters(['mid','userInfo','evidencePaymentPrice'])
  },
  methods: {
    init(){
       queryExistOrderItems().then(({ data }) => {
         console.log("选择存证文件：",data);
        this.fileList = data;
      });
      queryProductCategory(0).then(({ data }) => {
        // console.log("行业知识服务列表:", data);
        let list = [];
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          for (let n = 0; n < element.children.length; n++) {
            const elementChildren = element.children[n];
            list.push(elementChildren);
          }
        }
        this.queryProductCategory = list;
      });
    },
     chooseFile(){
      // let files=[];
      // for (let i = 0; i < this.form.evidenceFileIdx.length; i++) {
      //   const element = this.form.evidenceFileIdx[i];
      //   files.push(this.fileList[i*1]);
      // }
      // this.form.evidenceFile=files;
      
      //  console.log(this.form.evidenceFileIdx);
       this.form.evidenceFile = this.fileList[this.form.evidenceFileIdx];
      //  console.log(this.form.evidenceFile);
    },
      async onSubmit () {
      console.log("onSubmit..开始挂卖")
      try {
        const formBaseResult = await this.$refs['form'].validate()
        if(this.form.allow == false){
           this.$message.error("请了解并同意协议")
          return
        }
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error)
        this.mixinsScrollView()
        return
      }

      applyProduct({
        merchantId: 2,
        mid: this.mid,
        categoryId: this.form.categoryId,
        productName: this.form.subject,
        productType: '00',
        description: this.form.description,
        status:true
      }).then(({ data }) => {
        // console.log("提交请求接口1：",data);
        this.productId = data;

        applyGood({
          merchantId: 2,
          mid: this.mid,
          productId: this.productId,
          name: this.form.subject,
          fullName: this.form.subject,
          productType: '00',
          goodsType: this.form.agreementType,
          price: this.form.price,
          cost: '10',
          marketPrice: '10',
          basicAttribute: [],
          saleAttribute: [],
          describedAttribute: [],
          images: this.form.identityPicture,
          sliders:[],
          detailLinkUrl: "",
          shareLinkUrl:"",
          shippingMode:"00",
          shippingFee:"0",
          seckill:false,
          recommend:false,
          flashSales:false,
          supportProfit:false,
          membership:false,
          goodsStatus:"1",
          currency: 'cny',
          downloadUrl: this.form.evidenceFile.downloadUrl,
          source: '电脑校园',
          author: this.form.author,
          keyword: this.form.keyWords,
          description: this.form.description,
          extra:{
            existOrderNo: this.form.evidenceFile.orderNo,
            fileType: this.form.evidenceFile.fileType,
            abstracts: this.form.description2,
            // "bookName":书名,
          }
        }).then(({data}) => {
          console.log("提交请求接口2：返回商品id：",data);
          // 提交成功页面传参跳转
          this.$router.push({
            path:'/OnSale/DetailView',
            query:{goodsId: data,fromWhere:'inputForm'}
          });
        })
      });

     },
     uploadSuccess(res, file) {
        this.form.identityPicture = res.downloadUrl;
         this.$refs.uploader.clearValidate()
			},
			uploadBefore(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 5;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},
  }
}
</script>

<style lang='scss' scoped>
  @import "../../../../assets/css/inputForm.scss";
  .OnSaleForm{
    .formWrap{
      width:80%;
    }
    /deep/ .el-input{
      width:60%;
    }
    .rightTips{
      position: absolute;
      left: 60%;
      top:50%;
      transform: translate(16px,-50%);
      display: flex;
      align-items: center;
      .round{
        height:40px;
        width:40px;
        border-radius: 100%;
        background: #fff;
        border:solid 1px #979797;
      }
      .ract{
        height: 40px;
        border:solid 1px #979797;
        border-left: none;
        border-right:none;
        width:30px;
        background: #fff;
        margin-left: -20px;
      }
      .rightWords{
          p{
            display: flex;
            align-items: center;
            /deep/ .el-icon-caret-right{
              color:#979797;
              font-size: 18px;
              margin-left: -6px;
            }
          }
          .num{
            font-size: 18px;
            color:rgba(0, 0, 0,.85);
            margin-left: 2px;
          }
          .text{
            white-space: nowrap;
            margin-left: 4px;
            color:rgba(0, 18, 22,.65);
          }
      }
    }
  }
</style>
